import {
  Home,
  NotFound,
  Chat,
} from '../pages';

const routes = [
  {
    exact: true,
    path: '/',
    component: Home,
  },
  {
    exact: true,
    path: '/chats',
    component: Chat,
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes/routes.js